<template>
  <Modal class="modal-turn-off" id="notify-turn-off-confirm" #default="{ close }">
    <svg class="modal-turn-off__close" width="24" height="25" viewBox="0 0 24 25" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
      <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
    </svg>
    <div class="modal-turn-off__content">
      <div class="modal-turn-off__label">
        if you turn off all notifications, you won't receive pop-up messages about important things.
      </div>
      <div class="actions">
        <button class="border large" @click="handle">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.00009 6.00001C3.00009 3.23858 5.23867 1 8.00009 1C10.7615 1 13.0001 3.23858 13.0001 6V11.8986H3.00009V6.00001Z"
              stroke="#003882" stroke-width="2" />
            <path d="M5.75009 15.1749H10.2501" stroke="#003882" stroke-width="2" stroke-linecap="round" />
            <path d="M2.00009 2L14.3138 13.3137" stroke="#003882" stroke-width="2" stroke-linecap="round" />
          </svg>

          Turn off
        </button>
        <button class="primary border large" @click="close">Cancel</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue'
import { SvgIcon } from '@/components/ui'
import { mapMutations } from 'vuex'

export default {
  name: 'ModalTurnOff',
  components: { Modal, SvgIcon },
  methods: {
    handle() {
      this.closeModal()
    },
    ...mapMutations(['closeModal']),
  },
}
</script>

<style lang="scss">
.modal-turn-off {
  flex-direction: column;

  &__content {
    display: flex;
    flex-direction: column;
    width: 302px;

    @include mobile {
      width: 100%;
    }
  }

  &__close {
    align-self: flex-end;
    margin-bottom: 24px;
    cursor: pointer;
  }

  &__label {
    margin-bottom: 40px;
    text-align: center;

    font-size: 15px;
    font-weight: 400;
    line-height: 23.63px;
    color: #352A58;
  }

  .content {
    padding: 35px;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .actions {
    margin-top: 0;

    button {
      &:hover {
        svg {
          path {
            stroke: #CCD7E6;
          }
        }
      }
    }
  }
}
</style>
